export const formatPhoneNumber = phoneNumber => {
    if (!phoneNumber) {
        return '';
    }

    const digitsOnly = phoneNumber.replace(/\D/g, '');

    if (digitsOnly.startsWith('48') && digitsOnly.length === 11) {
        const countryCode = digitsOnly.slice(0, 2);
        const firstPart = digitsOnly.slice(2, 5);
        const secondPart = digitsOnly.slice(5, 8);
        const thirdPart = digitsOnly.slice(8, 11);
        return `+${countryCode} ${firstPart} ${secondPart} ${thirdPart}`;
    }

    if (digitsOnly.length === 9) {
        const firstPart = digitsOnly.slice(0, 3);
        const secondPart = digitsOnly.slice(3, 6);
        const thirdPart = digitsOnly.slice(6, 9);
        return `+48 ${firstPart} ${secondPart} ${thirdPart}`;
    }

    return phoneNumber;
};
